import { HelmetDexteel } from "@dexteel/mesf-core";
import { PartialRollsetsReport } from "./components/PartialRollsetsReport";

export const PartialRollsetsPage = () => {
	return (
		<>
			<HelmetDexteel title="Partial Rollsets" />
			<PartialRollsetsReport />
		</>
	);
};
